export function Header() {
    return (
        <header>
            <div>
                <a id="switch" href="/"><span></span></a>
            </div>
        </header>
    );
}
